// (B) Plain(플레인) TimePicker 백엔드 — antd TimePicker 대체. native <input type=time>.
//   값 계약 = 문자열 HH:mm. `.om-time-picker` hook. 소비처 0(kit API 전용).
import type { OmwTimePickerProps } from '../api/OmwTimePicker'
import { cx } from './cx'
import '../styles/omPicker.css'

export function PlainTimePicker({
  value,
  onChange,
  placeholder,
  disabled,
  className,
  style,
}: OmwTimePickerProps) {
  return (
    <input
      type="time"
      className={cx('om-time-picker', className)}
      value={value ?? ''}
      placeholder={placeholder}
      disabled={disabled}
      style={style}
      onChange={(e) => onChange?.(e.target.value)}
    />
  )
}
